import { render, staticRenderFns } from "./DayRedirect.vue?vue&type=template&id=06f716a2&"
import script from "./DayRedirect.vue?vue&type=script&lang=js&"
export * from "./DayRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports